module.exports = __webpack_public_path__ + "assets/img/page4-design-side-nav-expand-08473cd7.png";